import React, { useEffect, useState, useCallback, useRef } from "react";
import {
  Dropdown,
  Modal,
  Button,
  Tabs,
  Tab,
  Card,
  Row,
  Col,
  ButtonGroup,
} from "react-bootstrap";
import { Formik, Field, Form as FormikForm, ErrorMessage } from "formik";
import * as Yup from "yup";

import toast from "react-hot-toast";
import Spinner from "../components/Common/Spinner";
import {
  addFile,
  createNewAdmin,
  deleteAdmin,
  getUrl,
  updateAdminInfo,
  updateAdminStatus,
  verifyUser,
} from "../../services/Admin/adminServices";

import Pagination from "../components/Pagination";
import { useFetcher, useNavigate, useLocation } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import {
  getBLockedChats,
  getMISList,
  getReportedChats,
  getUserList,
  getWaitList,
} from "../../services/UserServices/UserService";
import LocationSearchDropdown from "../components/LocationAdd";
import { useSelector } from "react-redux";

const BlockedChats = () => {
  const [admins, setAdmins] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [locationText, setLocationText] = useState("");

  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const location = useLocation();
  const [currentPage, setCurrentPage] = useState(
    location.state?.currentPage ?? 0
  );
  const [itemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);

  const [type, setType] = useState("Verified");

  const navigate = useNavigate();

  const roleData = useSelector((state) => state.role.roles);

  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="12" cy="5" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="19" r="2"></circle>
      </g>
    </svg>
  );

  const fetchAdmins = useCallback(async () => {
    try {
      setLoading(true);
      const response = await getBLockedChats(currentPage, itemsPerPage);
      setAdmins(response?.data?.data?.data || []);

      setTotalItems(response?.data?.data?.total || 0);
    } catch (error) {
      console.error(error);
      toast.error("Failed to load data");
    } finally {
      setLoading(false);
    }
  }, [currentPage, itemsPerPage]);
  useEffect(() => {
    fetchAdmins();
  }, [fetchAdmins]);
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearch(search.trim());
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [search]);
  useEffect(() => {
    if (currentPage !== undefined) {
      navigate(".", {
        replace: true,
        state: { ...location.state, currentPage },
      });
    }
  }, [currentPage]);

  const isInitialMount = useRef(true);
  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
    setCurrentPage(0);
  }, [debouncedSearch, startDate, endDate, type]);

  const totalPages = Math.ceil(totalItems / itemsPerPage);

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h1 style={{ color: "#E5484D" }}>Blocked Users</h1>
      </div>

      {loading ? (
        <Spinner />
      ) : (
        <div className="table-responsive">
          <table className="table table-striped align-middle shadow-sm">
            <thead className="table-light">
              <tr>
                <th>Sr No.</th>
                <th>Blocked User</th>
                <th>Blocked By</th>
                

                <th>Blocked at</th>

             

                {/* <th style={{ textAlign: "center" }}>Action</th> */}
              </tr>
            </thead>
            <tbody>
              {admins?.length > 0 ? (
                admins.map((admin, index) => (
                  <tr key={admin._id || index}>
                    <td>{currentPage * itemsPerPage + index + 1}</td>
                    <td
                      className="text-primary cursor-pointer"
                      onClick={() =>
                        navigate(`/user-detail/${admin.blockedUser?._id}`)
                      }
                    >
                      {admin.blockedBy
                        ? `${admin.blockedUser.name
                            .charAt(0)
                            .toUpperCase()}${admin.blockedUser.name.slice(1)}`
                        : "_"}
                    </td>
                    <td
                      className="text-primary cursor-pointer"
                      onClick={() =>
                        navigate(`/user-detail/${admin.blockedBy?._id}`)
                      }
                    >
                      {admin.blockedBy
                        ? `${admin.blockedBy.name
                            .charAt(0)
                            .toUpperCase()}${admin.blockedBy.name.slice(1)}`
                        : "_"}
                    </td>
                  

                    <td>
                      {new Date(admin.createdAt).toLocaleDateString("en-CA", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      })}
                      {", "}
                      {new Date(admin.createdAt).toLocaleTimeString("en-CA", {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </td>

                
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center">
                    No data found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      <div className="card-footer clearfix mt-3">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center text-center text-md-start">
       <div
            className="dataTables_info fw-bold mb-3 mb-md-0"
            style={{ color: "#E5484D" }}
          >Total User : {totalItems}</div>
          <div className="d-flex align-items-center">
            {totalPages > 0 && (
              <Pagination
                pageCount={totalPages}
                pageValue={currentPage}
                setPage={setCurrentPage}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlockedChats;
